/**
 * ComplianceScoreBadge — Circular score indicator showing compliance percentage.
 * Green (≥90), Yellow (60-89), Red (<60).
 */

import { Shield, ShieldCheck, ShieldAlert } from 'lucide-react';

interface ComplianceScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md';
  showLabel?: boolean;
}

export function ComplianceScoreBadge({ score, size = 'sm', showLabel = false }: ComplianceScoreBadgeProps) {
  const color = score >= 90 ? 'text-green-600 bg-green-50 border-green-200'
    : score >= 60 ? 'text-amber-600 bg-amber-50 border-amber-200'
    : 'text-red-600 bg-red-50 border-red-200';

  const Icon = score >= 90 ? ShieldCheck : score >= 60 ? Shield : ShieldAlert;

  if (size === 'md') {
    return (
      <div className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 ${color}`}>
        <Icon className="h-4 w-4" />
        <span className="text-sm font-bold">{score}%</span>
        {showLabel && <span className="text-xs">Compliance</span>}
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 ${color}`} title={`Compliance: ${score}%`}>
      <Icon className="h-3 w-3" />
      <span className="text-[10px] font-bold">{score}%</span>
    </div>
  );
}
